export default __webpack_public_path__ + "static/media/android_step3.1d446d65.jpg";